export enum EnumTypeUpload {
    ARCHIVE_BUSINESS = 0,
    ARCHIVE_BL = 1,
    ARCHIVE_BILLING = 2,
    ARCHIVE_EXPENSE = 3,
}
